import SRC_textImg from '../assets/TEXT.png';

function headerBlock({ className }) {
    return (
        <div className={`w-full h-48 rounded-2xl bg-[#350A14] flex justify-center items-center ${className || ''}`}>
            <img className="w-full h-3/4 object-contain" src={SRC_textImg} alt="textImg" />
        </div>
    );
}

export default headerBlock;
